import * as React from "react";
import * as _ from 'lodash';
import { IProductCenter, IContact } from "@nkr/models/index";
import { FormControl, Glyphicon } from "react-bootstrap";
import moment from "moment";
import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IProps {
    productCenter: IProductCenter,
    staffList: IContact[],
    isClosed: boolean,
    onNextStepsChange: (productId: number, nextSteps: string) => void,
    onTargetDateChange: (productId: number, targetDate: string) => void,
    onCloseDateChange: (productId: number, targetDate: string) => void,
    onClosedByChange: (productId: number, closedBy: IContact) => void,
    onDeleteProduct: (productId: number) => void
}

interface IState { }

class Product extends React.Component<IProps, IState> {
    handleNextStepsChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.props.onNextStepsChange(this.props.productCenter.productId, e.currentTarget.value);
    }

    handleTargetDateChange = (e: moment.Moment) => {
        this.props.onTargetDateChange(this.props.productCenter.productId, e.format('MM/DD/YYYY'));
    }

    handleCloseDateChange = (e: moment.Moment) => {
        this.props.onCloseDateChange(this.props.productCenter.productId, e.format('MM/DD/YYYY'));
    }

    handleClosedByChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        let closedBy = this.props.staffList.find(x => x.id == parseInt(e.currentTarget.value));
        this.props.onClosedByChange(this.props.productCenter.productId, closedBy);
    }

    handleDeleteProduct = () => {
        this.props.onDeleteProduct(this.props.productCenter.productId);
    }

    render = () => {
        // Filter out Member Services and NKR Logistics contacts by name
        const staffList = _.sortBy(this.props.staffList.filter(x => 
            !x.fullName.toLowerCase().includes('member services') && 
            !x.fullName.toLowerCase().includes('logistics')
        ), [(item) => {
            return item.lastName;
        }]);

        return (
            <div className='product well'>
                <div className='row' style={{ marginBottom: 10 }}>
                    <div className='col-xs-12 col-lg-1'><strong>Product:</strong></div>
                    <div className='col-xs-12 col-lg-6'>
                        {!this.props.isClosed ?
                            <><strong>{this.props.productCenter.productName}</strong> <span style={{ color: '#a94442' }} onClick={this.handleDeleteProduct}><Glyphicon glyph='remove' /></span></>
                            :
                            <><strong>{this.props.productCenter.productName}</strong></>
                        }
                    </div>
                </div>

                <div className='row' style={{ marginBottom: 10 }}>
                    <div className='col-xs-12 col-lg-1'>Next Steps:</div>
                    <div className='col-xs-12 col-lg-6'>
                        {!this.props.isClosed ?
                            <FormControl
                                componentClass='textarea'
                                value={this.props.productCenter.nextSteps}
                                onChange={this.handleNextStepsChange}
                            />
                            :
                            <div>{this.props.productCenter.nextSteps}</div>
                        }
                    </div>
                </div>

                <div className='row' style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div className='col-xs-12 col-lg-1'>Target Date:</div>
                    <div className='col-xs-12 col-lg-2'>
                        {!this.props.isClosed ?
                            <DateTime
                                value={this.props.productCenter.targetDate}
                                input={true}
                                dateFormat={"MM/DD/YYYY"}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ className: "form-control" }}
                                onChange={this.handleTargetDateChange}
                            />
                            :
                            <div>{this.props.productCenter.targetDate}</div>
                        }
                    </div>
                </div>

                <div className='row' style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div className='col-xs-12 col-lg-1'>Close Date:</div>
                    <div className='col-xs-12 col-lg-2'>
                        {!this.props.isClosed ?
                            <DateTime
                                value={this.props.productCenter.closeDate}
                                input={true}
                                dateFormat={"MM/DD/YYYY"}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ className: "form-control" }}
                                onChange={this.handleCloseDateChange}
                            />
                            :
                            <div>{this.props.productCenter.closeDate}</div>
                        }
                    </div>
                </div>

                <div className='row' style={{ display: 'flex', alignItems: 'center' }}>
                    <div className='col-xs-12 col-lg-1'>Closed By:</div>
                    <div className='col-xs-12 col-lg-2'>
                        {!this.props.isClosed ?
                            <FormControl
                                componentClass='select'
                                value={this.props.productCenter.closedBy != null ? this.props.productCenter.closedBy.id : 0}
                                onChange={this.handleClosedByChange}
                            >
                                <option value={0}>- select -</option>
                                {staffList.map((item, index) =>
                                    <option key={'cb-' + index} value={item.id}>{item.lastName}, {item.firstName}</option>
                                )}
                            </FormControl>
                            :
                            <div>{this.props.productCenter.closedBy.fullName}</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default Product;